// FIXME
// eslint-disable-next-line workspaces/require-dependency
import { excerptLoad } from '@databases/connections/content/excerptLoad';
import {
  parseExcerptMacroHtml,
  parseExcerptMacroText,
} from '@databases/content-api/confluence/excerpt';
import { loadAsync } from '@databases/utils/redux/redux';
import { type AnyAction } from 'redux';
import { type ThunkAction } from 'redux-thunk';

import { type DefaultRootState } from '../../redux';
import {
  type ConnectionContentWithColumns,
  selectContentColumnStatus,
  selectContentOptional,
} from '../selectors';
import connectionsSlice, { type Content } from '../slice';

type Dispatcher<Result> = ThunkAction<Result, DefaultRootState, void, AnyAction>;

export const loadContentExcerpt = ({
  ari,
  forceReload,
}: {
  ari: string;
  forceReload?: boolean;
}): Dispatcher<Promise<ConnectionContentWithColumns | undefined>> => {
  return async (dispatch, getState) => {
    const content: Content | undefined = getState().connections.content[ari];
    if (!content) {
      return undefined;
    }

    await loadAsync(
      () => selectContentColumnStatus(getState().connections, ari, 'excerpt'),
      () => {
        dispatch(
          connectionsSlice.actions.loadContentColumnPending({ ari, column: 'excerpt' })
        );
      },
      async () => {
        const content = selectContentOptional(getState().connections, ari);
        if (!content) {
          throw new Error('Content not found');
        }

        const contentTitle = content.data['title']['text']; /**/
        const contentSpaceKey = content.data['space']['text'].split('/').at(-1);
        const excerptRawData = await excerptLoad(contentSpaceKey!, contentTitle);

        return {
          html: parseExcerptMacroHtml(excerptRawData.value),
          text: parseExcerptMacroText(excerptRawData.value),
        };
      },
      (excerpt) => {
        dispatch(
          connectionsSlice.actions.addColumnValueToContent({
            ari: content.ari,
            columnName: 'excerpt',
            data: {
              type: 'html',
              text: excerpt.html || '',
              value: excerpt.html || '',
            },
          })
        );
        dispatch(
          connectionsSlice.actions.loadContentColumnFinished({
            ari,
            column: 'excerpt',
          })
        );
      },
      (error) => {
        dispatch(
          connectionsSlice.actions.loadContentColumnError({
            ari,
            column: 'excerpt',
            error,
          })
        );
      },
      { forceReload }
    );

    return selectContentOptional(getState().connections, ari);
  };
};
